/**
 * Centralized logging utility for consistent log management across the application.
 * Automatically handles environment-based logging and provides standard log levels.
 */
const isDevelopment = import.meta.env.MODE === 'development';
const timestamp = () => new Date().toISOString();
const env = isDevelopment ? 'development' : 'production';

export const logger = {
  /**
   * Debug level logging - only shown in development
   */
  debug(...args: any[]) {
    if (isDevelopment) {
      const [message, ...rest] = args;
      console.debug(`[${timestamp()}] [DEBUG] [${env}]`, message, ...rest);
    }
  },
  
  /**
   * Info level logging - only shown in development
   */
  info(...args: any[]) {
    if (isDevelopment) {
      const [message, ...rest] = args;
      console.info(`[${timestamp()}] [INFO] [${env}]`, message, ...rest);
    }
  },
  
  /**
   * Warning level logging - shown in all environments
   */
  warn(...args: any[]) {
    const [message, ...rest] = args;
    if (isDevelopment || args.some(arg => arg instanceof Error)) {
      console.warn(`[${timestamp()}] [WARN] [${env}]`, message, ...rest);
    }
  },
  
  /**
   * Error level logging - shown in all environments
   */
  error(...args: any[]) {
    const [message, ...rest] = args;
    if (isDevelopment || args.some(arg => arg instanceof Error)) {
      console.error(`[${timestamp()}] [ERROR] [${env}]`, message, ...rest);
    }
  }
};

export default logger;
